<main role="main" class="home-page">
  <div style="padding-bottom: 3.75rem;" class="container footer">
    <div class="row">
      <div class="col-lg-9">
        <div class="row no-gutters">
          <div class="col-md-6 order-1 order-sm-0">
            <div class="logo-footer d-flex justify-content-between"><img class="img-fluid align-self-baseline"
                src="assets/media/images/logo-footer.png" alt="">
              <p>{{"footer.anpIntro" | translate}}.</p>
            </div>
          </div>
          <div class="col-md-6 order-0 order-sm-1">
            <div class="row row-cols-2 no-gutters">
              <div class="col-md-6 d-flex justify-content-start align-items-center">
                <div class="picto-circle"><span class="icon-help"></span></div>
                <div class="picto-text">{{"footer.aideSupport" | translate}}<br><a
                    href="{{langCode}}/acces-rapide/contact">{{"footer.contacteznous" | translate}}</a></div>
              </div>
              <div class="col-md-6 d-flex justify-content-start align-items-center">
                <div class="picto-circle"><span class="icon-professional"></span></div>
                <div class="picto-text">{{"footer.professionnel" | translate}}<br><a
                    href="{{langCode}}/acces-rapide/contact">{{"footer.contacteznous" | translate}}</a></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-11 d-flex justify-content-between footer-n2">
            <div class="adresse w-100"><span class="icon-map"></span>300, lotissement Mandarona , Sidi Maârouf, 20270
              Casablanca</div>
            <div class="phone w-50"><span class="icon-phone"></span>(+212) 520 121 314</div>
            <div class="fax w-50"><span class="icon-fax"></span>(+212) 522 786 102</div>
          </div>
        </div>
        <div class="row row-cols-2 text-center text-xs-center text-sm-left text-md-left menu-footer">
          <div class="col-xs-12 col-sm-4 col-md-2" *ngFor="let menu of MenuNiveau0">
            <h5>{{menu.Title}}</h5>
            <ul class="list-unstyled quick-links">
              <li *ngFor="let Sitem of getSousMenu(menu.Id)"><a [routerLink]="['/'+ Sitem.ApplicationUrl]" routerLinkActive="router-link-active" href="javascript:void(0)">{{Sitem.Title}}</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="titre-footer">{{"footer.RetrouverActualites" | translate}} </div>
        <p>{{"footer.SAbonner" | translate}}</p>
        <form>
          <div class="form-group">
            <input id="emailinp" class="form-control" placeholder="Votre Adresse email" type="email" [(ngModel)] ="email" name="email"
              aria-describedby="emailHelp" >
            <button class="btn btn-link" type="submit"  [routerLink]="['/publications/newsletter']" routerLinkActive="router-link-active"  [queryParams]="{mail: email}"><span class="icon-long-right-arrow"></span></button>
          </div>
          <p>{{"footer.RGPD" | translate}} <a href="javascript:void(0)">{{"footer.RGPD2" | translate}}</a></p>
        </form>
        <p>{{"footer.ReseauxSociaux" | translate}}</p>
        <div class="d-flex justify-content-between social-links">
              <a class="facebook" href="https://www.facebook.com/ANPMaroc"><img src="assets/media/images/facebook-icon.svg" alt=""></a>
              <a class="linkedin" href="https://www.linkedin.com/company/agence-nationale-des-ports-maroc/"><img src="assets/media/images/LinkedIn_icon_circle.svg" alt=""></a>
              <a class="twitter" href="https://twitter.com/AnpMaroc"><img src="assets/media/images/twitter-icon.svg" alt=""></a>
              <a class="youtube" href="https://www.youtube.com/channel/UCDd_7d4_8ft8JPyIWhIw1eQ"><img src="assets/media/images/youtube-icon.svg" alt=""></a>
        </div>
      </div>
    </div>
    <div class="row footer-bottom">
      <div class="col-md-8">
        <ul class="nav align-content-start">
          <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" [routerLink]="['/acces-rapide', 'LegalNotice']">{{"footer.MentionLegal" | translate}}</a></li>
          <li class="nav-item" *ngIf="langCode === 'fr'"><a class="nav-link" href="javascript:void(0)" [routerLink]="['/acces-rapide', 'lexique']">Lexique</a></li>
          <li class="nav-item"><a class="nav-link" href="javascript:void(0)">{{"footer.RGPD2" | translate}}</a></li>
        </ul>
      </div>
      <div class="col-md-4 align-content-end text-right">
        <div>© Agence Nationale des Ports 2021</div>
      </div>
    </div>
  </div>
  <a class="c-action__gototop" (click)="goToTop()" href="javascript:void(0)" title="Haut de page"></a>
</main>